import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView, searchResults } from 'utils/store';

export const useSearchResults = () => {
  const { pathname } = useLocation();
  const { page, reset, searchTerm: existingSearchTerm, setSearchTerm } = searchResults();
  const pageView = useMemo(() => pathname.slice(7).split('/')[0], [pathname]);

  useEffect(() => {
    if (page && !pathname.includes(page)) {
      reset();
    }
  }, [pathname]);

  const updateSearchTerm = (term: string) => {
    setSearchTerm(term, pageView as pageView);
  };

  return {
    existingSearchTerm,
    updateSearchTerm,
  };
};
